import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
  standalone: true,
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, capitalizationMethod: 'allUpperCase' | 'titleCase' | 'sentenceCase'): string {
    if (Array.isArray(value) && (value[0] === '¡' || value[0] === '¿')) {
      return value[0] + value[1].toUpperCase() + value.substr(2).toLowerCase();
    }

    if (capitalizationMethod === 'allUpperCase') {
      return value.toUpperCase();
    } else if (capitalizationMethod === 'titleCase') {
      const splitString = value?.split(' ').map((s) => this.bypassSpecialCharacterAtStartOfTheWord(s));
      return splitString.join(' ');
    } else if (capitalizationMethod === 'sentenceCase') {
      const splitString = value?.split('.').map((s) => {
        const trimmedString = s.trim();
        if (trimmedString.length > 0) {
          return this.bypassSpecialCharacterAtStartOfTheWord(trimmedString);
        }
        return '';
      });
      return splitString?.join('. ');
    }
    return '';
  }

  private bypassSpecialCharacterAtStartOfTheWord(word: string): string {
    if (word[0] === '¡' || word[0] === '¿') {
      return word[0] + word[1].toUpperCase() + word.slice(2);
    } else {
      return word[0].toUpperCase() + word.slice(1);
    }
  }
}
